import { BaseModel, attr } from "../../lib/itn-ui-kit/data";

export default class ContactModel extends BaseModel {
  @attr("string") name;
  @attr("string") phone;
  @attr("string") email;
  @attr("json") address;
  @attr("string") companyName;
  @attr("string") relationType;
}
